export const toGoogleSheetsLink = (docId: string, sheetId?: string) => {
  const l = `https://docs.google.com/spreadsheets/d/${docId}`;
  return sheetId ? `${l}#gid=${sheetId}` : l;
};

export const toGoogleDocLink = (docId: string) => {
  const l = `https://docs.google.com/document/d/${docId}`;
  return l;
};

export const toGoogleDriveLink = (folderId: string) => {
  return `https://drive.google.com/drive/folders/${folderId}`;
};
